export default {
  de_de: {
    download:
      'https://www.flipsnack.com/takeawaycom/lieferando-report-2021-xje1wwq95e.html',
    navbar: {
      logo: 'lieferando',
      button_text: 'PDF herunterladen',
      home_link: 'https://www.lieferando.de/'
    },
    intro: {
      hero: 'chickpea-hero',
      title: 'Der Lieferando Report',
      subtitle: 'So bestellt Deutschland',
      body:
        'Neuigkeiten, Fakten und Trends über die Essgewohnheiten, das Bestellverhalten und die neuesten Food Trends in Deutschland'
    },
    favourites: {
      title: 'So bestellt Deutschland',
      subtitle: 'Nationale Favoriten und Trends',
      image: 'dahl',
      body_1:
        'Die beliebtesten Küchenrichtungen und ihre jeweiligen Top 3 Gerichte',
      food_items: [
        {
          image: 'pizza-plate',
          cuisine: 'Italienisch',
          top: ['Pizza Salami', 'Pizza Margherita', 'Pizza Mista'],
          color: 'cupcake'
        },
        {
          image: 'burger',
          cuisine: 'Amerikanisch',
          top: ['Cheeseburger', 'Beef Burger', 'Chicken Nuggets'],
          color: 'orange'
        },
        {
          image: 'sushi',
          cuisine: 'Sushi / Japanisch',
          top: ['Poke Bowl', 'Inside Out Roll Sake Avocado', 'Yana Sushi Roll'],
          color: 'tumeric'
        },
        {
          image: 'chinese',
          cuisine: 'Chinesisch',
          top: [
            'Gebratene Nudeln mit Hühnerfleisch',
            'Gebratener Reis',
            'Knusprige Ente mit Erdnusssauce'
          ],
          color: 'berry'
        },
        {
          image: 'kebab',
          cuisine: 'Kebab',
          top: ['Döner Teller', 'Dürüm Döner', 'Jumbo Döner'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Veggie',
        body_1:
          'Vegetarische und vegane Ernährung wächst in ihrer Beliebtheit. Das zeigen auch die Bestellzahlen.',
        body_2:
          'So wurden 75% mehr vegetarische und vegane Gerichte bestellt als noch im Vorjahr.'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Vegetarische Favoriten',
        dishes: [
          {
            name: 'Pizza Margherita',
            image: 'pizza-slice',
            color: 'cupcake'
          },
          {
            name: 'Buddha Bowl',
            image: 'bowl-icon',
            color: 'berry'
          },
          {
            name: 'Avocado Maki',
            image: 'sushi-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Vegane Favoriten:',
        dishes: [
          'Big Vegan Ts',
          'Veganer Cheeseburger',
          'Vegane Country Potatoes'
        ],
        image: 'veggie-burger'
      }
    },
    cuisines: {
      title: 'Die Aufsteiger',
      subtitle:
        'Diese Küchenrichtungen und Gerichte sind am schnellsten gewachsen',
      country: {
        title: 'Küchenrichtungen',
        list: [
          'Nord-Afrikanisch +27%',
          'Deutsch +21%',
          'Portugiesisch +20%',
          'Vietnamesisch +20%',
          'Amerikanisch / Burger +19%'
        ]
      },
      dish: {
        title: 'Gerichte',
        list: [
          'Chicken Buddha Bowl',
          'Spaghetti Chitarra Ragu',
          'Yellow Thai Curry',
          'Little Bacon Cheeseburger',
          'Chicken Bowl'
        ]
      },
      image: 'wrap'
    },
    cities: {
      title: 'Liefer-Fans',
      subtitle: 'In diesen 10 Städten wird am häufigsten bestellt',
      list: [
        'Berlin',
        'Hamburg',
        'München',
        'Köln',
        'Frankfurt am Main',
        'Düsseldorf',
        'Hannover',
        'Dortmund',
        'Leipzig',
        'Essen'
      ]
    },
    maps: {
      title: 'So bestellen die Bundesländer ',
      image: 'map-de',
      subtitle: 'Regionale Favoriten und Trends',
      body_1: 'Die beliebtesten Küchenrichtungen und Gerichte der Bundesländer',
      body_2: '',
      locations: [
        {
          city: 'Berlin',
          top: '360px',
          left: '600px',
          cuisines: [
            {
              cuisine: 'Meistbestellte Küche: Japanisch',
              image: 'sushi',
              top_title: 'Die meistbestellten Gerichte:',
              top: ['Cheeseburger', 'Sushi Lachs Menü', 'Butter chicken'],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Hamburg',
          top: '190px',
          left: '350px',
          cuisines: [
            {
              cuisine: 'Meistbestellte Küche: Italienisch / Pizza',
              image: 'pizza-plate',
              top_title: 'Die meistbestellten Gerichte:',
              top: ['Cheeseburger', 'Dönerteller', 'Dürüm Döner'],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Köln',
          top: '550px',
          left: '100px',
          cuisines: [
            {
              cuisine: 'Meistbestellte Küche: Italienisch / Pizza',
              image: 'pizza-slice',
              top_title: 'Die meistbestellten Gerichte:',
              top: ['Cheeseburger', 'Pizza Margherita', 'Pizza Tonno'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Düsseldorf',
          top: '500px',
          left: '60px',
          cuisines: [
            {
              cuisine: 'Meistbestellte Küche: Italienisch / Pizza',
              image: 'pizza-box',
              top_title: 'Die meistbestellten Gerichte:',
              top: ['Cheeseburger', 'Pizza Margherita', 'Big Mac'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Frankfurt',
          top: '740px',
          left: '220px',
          cuisines: [
            {
              cuisine: 'Meistbestellte Küche: Italienisch / Pizza',
              image: 'pizza-plate',
              top_title: 'Die meistbestellten Gerichte:',
              top: ['Cheeseburger', 'Chicken Tikka Masala', 'Butter Chicken'],
              color: 'tomato'
            }
          ]
        },
        {
          city: 'München',
          top: '900px',
          left: '420px',
          cuisines: [
            {
              cuisine: 'Meistbestellte Küche: Italienisch / Pizza',
              image: 'pizza-box',
              top_title: 'Die meistbestellten Gerichte:',
              top: ['Butter Chicken', 'Big Mac', 'Cheeseburger'],
              color: 'orange'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: 'Hungrig auf mehr Daten?',
      body: 'Hier den auführlichen Report downloaden',
      button: 'Herunterladen'
    },
    footer: {
      title: 'Pressekontakt',
      contacts: [
        {
          company: 'PIABO PR:',
          name: 'Alisa Findling',
          email: 'lieferando@piabo.net',
          number: '+49 152 034798 19'
        },
        {
          company: 'Lieferando:',
          name: 'Ann-Kathrin Donwald',
          email: 'ann-kathrin.donwald@justeattakeaway.com'
        }
      ]
    }
  },
  pl_pl: {
    download:
      'https://www.flipsnack.com/takeawaycom/2021-food-trends-report-poland.html',
    navbar: {
      logo: 'pyszne',
      button_text: 'ściągnij PDF',
      home_link: 'https://www.pyszne.pl/'
    },
    intro: {
      hero: 'burger-hero',
      title: 'Raport Food Trendów Pyszne.pl 2021',
      subtitle: 'Fakty, liczby i trendy dotyczące jedzenia z dostawą',
      body:
        'Kulinarne nowinki, zwyczaje żywieniowe i inne jedzeniowe ciekawostki'
    },
    favourites: {
      title: 'Co mamy na talerzu?',
      subtitle: `Zwyczaje jedzeniowe Polaków`,
      image: 'dahl',
      body_1: 'Kuchnie i potrawy, które uwielbiamy',
      body_2: 'Co jest górą - pizza czy kotlet?',
      food_items: [
        {
          image: 'pizza-plate',
          cuisine: 'Włoska',
          top: ['Pizza capricciosa', 'Pizza margherita', 'Spaghetti bolognese'],
          color: 'cupcake'
        },
        {
          image: 'burger',
          cuisine: 'Amerykańska',
          top: ['Cheeseburger', 'Burger klasyczny', 'Frytki belgijskie'],
          color: 'orange'
        },
        {
          image: 'pierogi',
          cuisine: 'Polska',
          top: ['Kotlet schabowy', 'Pierogi ruskie', 'Rosół z makaronem'],
          color: 'tumeric'
        },
        {
          image: 'chinese',
          cuisine: 'Chińska',
          top: [
            'Kurczak słodko-kwaśny',
            'Ryż smażony z kurczakiem',
            'Kaczka po pekińsku'
          ],
          color: 'berry'
        },
        {
          image: 'sushi',
          cuisine: 'Japońska',
          top: ['Sushi', 'Kurczak Teriyaki', 'Ramen'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Wegetariańskie i wegańskie jedzenie',
        body_1:
          'Zyskuje na popularności wśród zamówień z dostawą, ze wzrostem o',
        body_2: '49%'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Ulubione dania kuchni wegetariańskiej:',
        dishes: [
          {
            name: 'Pizza vegetariana',
            image: 'pizza-slice',
            color: 'cupcake'
          },
          {
            name: 'Wegetariański burger',
            image: 'burger-icon',
            color: 'berry'
          },
          {
            name: 'Sajgonki wegetariańskie',
            image: 'wrap-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Ulubione dania kuchni wegańskiej:',
        dishes: ['Wegański kebab', 'Wegański burger', 'Wegańskie nuggetsy'],
        image: 'veggie-burger'
      }
    },
    cuisines: {
      title: 'Na czasie',
      subtitle: 'Kuchnie, które szybko zyskują na popularności',
      country: {
        title: 'Kuchnia',
        list: [
          'Grecka + 18%',
          'Amerykańska - Burgery + 18%',
          'Tajska +18% ',
          'Polska + 15%',
          'Arabska +15%'
        ]
      },
      dish: {
        title: '',
        list: []
      },
      image: 'wrap'
    },
    cities: {
      title: 'Najwięksi fani jedzenia z dostawą',
      subtitle: 'Miasta z największą liczbą zamówień',
      list: [
        'Warszawa',
        'Kraków',
        'Wrocław',
        'Poznań',
        'Łódź',
        'Gdańsk',
        'Szczecin',
        'Lublin',
        'Katowice',
        'Rzeszów'
      ]
    },
    maps: {
      title: 'Jak jedzą mieszkańcy największych miast?',
      subtitle: 'Lokalna specyfika',
      body_1: 'Najpopularniejsze dania w każdym mieście',
      body_2: '',
      image: 'map-pl',
      locations: [
        {
          city: 'Warszawa',
          top: '400px',
          left: '460px',
          cuisines: [
            {
              image: 'curry',
              top_title: 'Najlepsze dania',
              top: ['Curry z kurczakiem', 'Kebab', 'Kotlet schabowy'],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Kraków',
          top: '720px',
          left: '400px',
          cuisines: [
            {
              image: 'curry',
              top_title: 'Najlepsze dania',
              top: [
                'Kurczak po wietnamsku',
                'Curry z kurczakiem',
                'Kotlet schabowy'
              ],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Wrocław',
          top: '560px',
          left: '80px',
          cuisines: [
            {
              image: 'kebab',
              top_title: 'Najlepsze dania',
              top: ['Pad thai z kurczakiem', 'Curry z kurczakiem', 'Kebab'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Poznań',
          top: '400px',
          left: '130px',
          cuisines: [
            {
              image: 'pizza-slice',
              top_title: 'Najlepsze dania',
              top: [
                'Pad thai z kurczakiem',
                'Kotlet schabowy',
                'Curry z kurczakiem'
              ],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Łódź',
          top: '490px',
          left: '330px',
          cuisines: [
            {
              image: 'pizza-plate',
              top_title: 'curry',
              top: [
                'Kurczak w panierce',
                'Kurczak w cieście',
                'Butter Chicken'
              ],
              color: 'tomato'
            }
          ]
        },
        {
          city: 'Gdańsk',
          top: '160px',
          left: '220px',
          cuisines: [
            {
              image: 'pizza-box',
              top_title: 'Najlepsze dania',
              top: ['Cheeseburger', 'Pizza margherita', 'Kurczak gong bao '],
              color: 'orange'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: 'Masz apetyt na więcej?',
      body: 'Pobierz pełny raport',
      button: 'ściągnij PDF'
    },
    footer: {
      title: 'Kontakt dla mediów',
      contacts: [
        {
          name: 'Agnieszka Piotrowska',
          email: 'a.piotrowska@lensomai.com'
        },
        {
          name: 'Rafał Wojtczak',
          email: 'rafal.wojtczak@justeattakeaway.com'
        }
      ]
    }
  },
  nl_nl: {
    download:
      'https://www.flipsnack.com/takeawaycom/thuisbezorgd-food-trend-rapport-2021.html',
    navbar: {
      logo: 'thuisbezorgd',
      button_text: 'Download PDF',
      home_link: 'https://www.thuisbezorgd.nl/'
    },
    intro: {
      hero: 'chickpea-hero',
      title: 'Thuisbezorgd Food Trend Rapport 2021',
      subtitle: '',
      body:
        'Food trends en inzichten in eetgewoontes en de online bezorgmarkt in Nederland.'
    },
    favourites: {
      title: 'Dit bestelt Nederland. Een landelijke analyse.',
      subtitle: 'Nationale trends',
      image: 'poke-salmon',
      body_1: 'De top 5 populairste keukens van Nederland.',
      food_items: [
        {
          image: 'pizza-plate',
          cuisine: 'Italiaans',
          top: ['Pizza margherita', 'Pizza salami', 'Quattro formaggi'],
          color: 'cupcake'
        },
        {
          image: 'sushi',
          cuisine: 'Japans',
          top: ['Crispy ebi', 'Dragon roll', 'California roll'],
          color: 'orange'
        },
        {
          image: 'burger',
          cuisine: 'Amerikaans',
          top: ['Hamburger', 'Kipburger', 'Cheeseburger'],
          color: 'tumeric'
        },
        {
          image: 'chinese',
          cuisine: 'Chinees',
          top: ['Wok', 'Babi pangang', 'Sichuan kip'],
          color: 'berry'
        },
        {
          image: 'curry',
          cuisine: 'Indiaas',
          top: ['Butter chicken', 'Chicken tikka masala', 'Saag paneer'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Vegetarisch en veganistisch',
        body_1:
          'Vegetarisch en veganistisch eten wordt steeds populairder. Het aantal bestellingen van deze gerechten groeide met maar liefst',
        body_2: '57%'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Meest populaire vegetarische gerechten:',
        dishes: [
          {
            name: 'Vegetarische pizza',
            image: 'pizza-plate',
            color: 'cupcake'
          },
          {
            name: 'Vegetarische kipburger',
            image: 'burger-icon',
            color: 'berry'
          },
          {
            name: 'Californian veggie pizza',
            image: 'pizza-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Meest populaire veganistische gerechten',
        dishes: [
          'Vegan burger',
          'Vegan funghi pizza',
          'Vegan pizza margherita'
        ],
        image: 'veggie-burger'
      }
    },
    cuisines: {
      title: 'Deze keukens en gerechten winnen snel aan populariteit',
      subtitle: 'Deze keukens winnen snel aan populariteit',
      country: {
        title: 'Keuken',
        list: [
          'Amerikaans',
          'Midden-Oosters',
          'Marokkaans',
          'Japans',
          'Indiaas'
        ]
      },
      dish: {
        title: 'Maaltijden',
        list: [
          'Pita falafel ',
          'Hamburger',
          'Club Sandwich',
          'Couscous',
          'Poké bowl'
        ]
      },
      image: 'wrap'
    },
    cities: {
      title: 'Thuisbezorgd.nl fans',
      subtitle: 'De top 10 steden met de meeste bestellingen',
      list: [
        'Amsterdam',
        'Rotterdam',
        'Den Haag',
        'Utrecht',
        'Groningen',
        'Tilburg',
        'Eindhoven',
        'Almere',
        'Leiden',
        'Enschede'
      ]
    },
    maps: {
      title: 'Regionale food analyse',
      subtitle: 'Lokale favorieten',
      body_1:
        'Ontdek hier de meest populaire gerechten in een aantal provincies.',
      body_2: 'Download het rapport hieronder voor meer provincies.',
      image: 'map-nl',
      locations: [
        {
          city: 'Noord-Holland',
          top: '300px',
          left: '200px',
          cuisines: [
            {
              cuisine: 'Keuken: Italiaans',
              image: 'pizza-box',
              top_title: 'Gerechten',
              top: ['Pizza margherita', 'Butter chicken', 'Kapsalon döner'],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Limburg',
          top: '600px',
          left: '500px',
          cuisines: [
            {
              cuisine: 'Keuken: Italiaans',
              image: 'pizza-plate',
              top_title: 'Gerechten',
              top: ['Kapsalon döner', `Taco's`, 'Hamburger'],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Zuid-Holland',
          top: '450px',
          left: '200px',
          cuisines: [
            {
              cuisine: 'Keuken: Italiaans',
              image: 'pizza-slice',
              top_title: 'Gerechten',
              top: ['Wok', 'Hamburger', 'Pizza margherita'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Groningen',
          top: '100px',
          top_title: 'Gerechten',
          left: '650px',
          cuisines: [
            {
              cuisine: ' Keuken: Italiaans',
              image: 'pizza-box',
              top: ['Kapsalon döner', 'Poké bowl', 'Hamburger'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Friesland',
          top: '150px',
          top_title: 'Gerechten',
          left: '470px',
          cuisines: [
            {
              cuisine: 'Keuken: Italiaans',
              image: 'pizza-plate',
              top: ['Wok', 'Kapsalon döner', 'Pizza salami'],
              color: 'tomato'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: 'Meer interessante data?',
      body: 'Download het rapport',
      button: 'Download'
    },
    footer: {
      title: 'Contact',
      contacts: [
        {
          company: 'Thuisbezorgd.nl',
          name: 'Lieke Peters',
          email: 'lieke.peters@justeattakeaway.com'
        },
        {
          company: 'Ovide Agency',
          name: 'Kitty van Muiswinkel',
          email: 'thuisbezorgd@ovide.agency'
        }
      ]
    }
  },
  fr_fr: {
    download:
      'https://www.flipsnack.com/takeawaycom/2021-food-trends-report-france.html',
    navbar: {
      logo: 'just-eat',
      button_text: 'Télécharger le PDF',
      home_link: 'https://www.just-eat.fr/'
    },
    intro: {
      hero: 'burger-hero',
      title: 'DATALICIOUS',
      subtitle: '3ème édition',
      body: `L'OBSERVATOIRE DES NOUVEAUX MODES DE RESTAURATION 2021`
    },
    favourites: {
      title: 'Tendances Food :',
      subtitle: `l'analyse nationale`,
      image: 'poke-tuna',
      body_1: 'Le Top 5 des commandes en France en 2021',
      food_items: [
        {
          image: 'burger',
          cuisine: 'BURGER',
          top: ['Cheeseburger', 'Hamburger', 'Burger cheese & bacon'],
          color: 'cupcake'
        },
        {
          image: 'sushi',
          cuisine: 'JAPONAIS',
          top: ['Soupe miso', 'Sushi saumon', 'California saumon avocat'],
          color: 'orange'
        },
        {
          image: 'pizza-plate',
          cuisine: 'PIZZA',
          top: ['4 fromages', 'Orientale', 'Tartiflette'],
          color: 'tumeric'
        },
        {
          image: 'curry',
          cuisine: 'INDIEN',
          top: ['Naan au fromage', 'Butter chicken', 'Poulet tikka massala'],
          color: 'berry'
        },
        {
          image: 'chinese',
          cuisine: 'CHINOIS',
          top: [
            'Nouilles sautées aux légumes',
            'Boeuf aux oignons',
            'Canard laqué'
          ],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title:
          'Même sans viande, le burger est toujours en tête des plats préférés !',
        body_1: `Dans ce top des spécialités vegan et végétariennes on retrouve le burger et la pizza, les deux incontournables de la restauration livrée. La street food ne cesse de se décliner pour s'adresser à tous. `,
        body_2:
          'Comme quoi, cuisine sans viande rime aussi avec cuisine gourmande !'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Végétarien:',
        dishes: [
          {
            name: 'Burger végétarien',
            image: 'veggie-burger',
            color: 'cupcake'
          },
          {
            name: 'Bo-bun végétarien',
            image: 'kebab-icon',
            color: 'berry'
          },
          {
            name: 'Kebab végétarien',
            image: 'bao-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Vegan:',
        dishes: ['Burger vegan', 'Pad Thaï vegan', 'Pizza vegan'],
        image: 'dahl'
      }
    },
    cuisines: {
      title: 'Tops & Flops, les tendances françaises passées au crible',
      subtitle: 'Les Tops, ces tendances populaires',
      country: {
        title: 'Cuisines',
        list: ['Thaïlandais', 'Chinois', 'Burger', 'Indien']
      },
      dish: {
        title: 'Vaisselle',
        list: []
      },
      image: 'wrap'
    },
    cities: {
      title: 'Les fans de livraison',
      subtitle:
        'TOP 10 des villes où la restauration livrée est ancrée dans les habitudes',
      list: [
        'Paris',
        'Marseille',
        'Toulouse',
        'Lille',
        'Lyon',
        'Montpellier',
        'Strasbourg',
        'Nice',
        'Nantes',
        'Bordeaux'
      ]
    },
    maps: {
      title: 'Livraison de repas :',
      subtitle: 'Zoom en régions',
      body_1:
        'Un aperçu des spécialités livrées les plus populaires dans certaines régions.',
      body_2:
        'Téléchargez le rapport complet Datalicious pour retrouver les spécialités livrées de toutes les régions de France.',
      image: 'map-fr',
      locations: [
        {
          city: 'Auvergne-Rhône-Alpes',
          top: '560px',
          left: '600px',
          cuisines: [
            {
              cuisine: 'Burger',
              image: 'burger',
              top: [
                'Burger façon steakhouse',
                'Cheeseburger',
                'Burger au poulet'
              ],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Bourgogne-Franche-Comté',
          top: '360px',
          left: '600px',
          cuisines: [
            {
              cuisine: 'Burger',
              image: 'egg-burger',
              top: [
                'Butter chicken',
                'Burger façon steakhouse',
                'Poulet tikka massala'
              ],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Bretagne',
          top: '280px',
          left: '120px',
          cuisines: [
            {
              cuisine: 'Burger',
              image: 'veggie-burger',
              top: ['Tacos', 'Burger', 'Kebab'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Centre-Val de Loire',
          top: '360px',
          left: '370px',
          cuisines: [
            {
              cuisine: 'Burger',
              image: 'burger',
              top: ['Tacos', 'Pizza', 'Kebab'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Hauts-de-France',
          top: '100px',
          left: '540px',
          cuisines: [
            {
              cuisine: 'Burger',
              image: 'egg-burger',
              top: ['Cheeseburger', 'Burger façon steakhouse', 'Tiramisu'],
              color: 'tomato'
            }
          ]
        },
        {
          city: 'Grand Est',
          top: '200px',
          left: '640px',
          cuisines: [
            {
              cuisine: 'Burger',
              image: 'veggie-burger',
              top: ['Cheeseburger', 'Nuggets de poulet', 'Nems au poulet'],
              color: 'orange'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: `Envie d'en savoir plus?`,
      body: 'Télécharger le rapport complet',
      button: 'Télécharger le PDF'
    },
    footer: {
      title: 'Contacts presse:',
      contacts: [
        {
          company: 'Just Eat',
          name: 'Anne-Sophie Capard',
          email: 'annesophie.capard@justeattakeaway.com',
          number: 'M: +31(0)6.28.32.43.76'
        },
        {
          company: 'Albine & Co',
          name: 'Jade Pérignon',
          email: 'j.perignon@albineco.com',
          number: 'M: 07.70.28.59.95'
        },
        {
          company: 'Just Eat France',
          address: '2ter, rue Louis Armand, 75015 Paris'
        }
      ]
    }
  },
  es_es: {
    download:
      'https://www.flipsnack.com/takeawaycom/el-gastr-metro-2021-de-just-eat.html',
    navbar: {
      logo: 'just-eat',
      button_text: 'Descargar PDF',
      home_link: 'https://www.just-eat.es/'
    },
    intro: {
      hero: 'pancake-hero',
      title: 'El Gastrómetro 2021 de Just Eat',
      subtitle: 'Informe sobre las tendencias de comida a domicilio',
      body:
        'Novedades gastronómicas, hábitos de consumo y otros datos relacionados con la comida a domicilio en España del 2020-2021'
    },
    favourites: {
      title: 'Análisis nacional de comida a domicilio',
      subtitle: `¿Qué hay en tu menú, España? Datos y tendencias nacionales`,
      image: 'sushi',
      body_1: 'Los tipos de cocina y platos más pedidos',
      body_2: 'Sushi o ensaladilla rusa, ¡hagan sus apuestas!',
      food_items: [
        {
          image: 'burger',
          cuisine: 'Americana',
          top: [
            'Hamburguesa de ternera',
            'Hamburguesa de pollo',
            'Alitas de pollo'
          ],
          color: 'cupcake'
        },
        {
          image: 'pizza-plate',
          cuisine: 'Italiana',
          top: ['Pizza carbonara', 'Pizza barbacoa', 'Tiramisú'],
          color: 'orange'
        },
        {
          image: 'chinese',
          cuisine: 'Oriental',
          top: [
            'Arroz tres delicias',
            'Pollo con almendras',
            'Cerdo agridulce'
          ],
          color: 'tumeric'
        },
        {
          image: 'sushi',
          cuisine: 'Japonesa',
          top: ['Edamame', 'Yakisoba', 'Maki salmón'],
          color: 'berry'
        },
        {
          image: 'ensaladilla',
          cuisine: 'Española',
          top: ['Ensaladilla rusa', 'Patatas ali-oli', 'Tortilla de patatas'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Vegetariana y vegana',
        body_1:
          'La comida vegetariana y vegana destacan por su auge en el delivery con un aumento del 50% y el 80% respectivamente'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Platos favoritos de la comida vegetariana:',
        dishes: [
          {
            name: 'Hamburguesa vegetariana',
            image: 'veggie-burger',
            color: 'cupcake'
          },
          {
            name: 'Crema de verduras',
            image: 'burger-icon',
            color: 'berry'
          },
          {
            name: 'Callos vegetarianos',
            image: 'wrap-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Platos favoritos de la comida vegana:',
        dishes: [
          'Wrap con guacamole y queso vegano',
          'Samosas',
          'Hamburguesa vegana'
        ],
        image: 'kebab'
      }
    },
    cuisines: {
      title: 'Los más trendy',
      subtitle: 'Los tipos de cocina y platos en tendencia',
      country: {
        title: 'Cocinas',
        list: [
          'Desayuno +464%',
          'Argentina +375%',
          'Alta cocina +345%',
          'Africana +323%',
          'Mediterránea +220%'
        ]
      },
      dish: {
        title: 'Platos',
        list: [
          'Rabo de Toro',
          'Carrilleras',
          'Cachopo',
          'Tequeños',
          'Empanadillas'
        ]
      },
      image: 'wrap'
    },
    cities: {
      title: 'Las ciudades más populares ',
      subtitle: 'Los 10 lugares con mayor demanda de comida a domicilio',
      list: [
        'Madrid',
        'Barcelona',
        'Valencia',
        'Sevilla',
        'A Coruña',
        'Málaga',
        'Vigo',
        'Granada',
        'Palma de Mallorca',
        'Bilbao'
      ]
    },
    maps: {
      title: 'Análisis de la comida a domicilio a nivel regional',
      subtitle: 'Los favoritos locales',
      body_1: 'Lo más pedido por provincia',
      body_2: '',
      image: 'map-es',
      locations: [
        {
          city: 'Madrid',
          top: '200px',
          left: '400px',
          cuisines: [
            {
              cuisine: 'Tipo de cocina: Americana',
              image: 'burger',
              top_title: 'Plato',
              top: [
                'Plato: Hamburguesa de ternera',
                'Plato local: Huevos rotos con jamón'
              ],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Barcelona',
          top: '150px',
          left: '550px',
          cuisines: [
            {
              cuisine: 'Tipo de cocina: Italiana',
              image: 'pizza-slice',
              top_title: 'Plato',
              top: ['Plato: Pizza barbacoa', 'Plato local: Patatas bravas'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Valencia',
          top: '250px',
          left: '480px',
          cuisines: [
            {
              cuisine: 'Tipo de cocina: Italiana',
              image: 'pizza-plate',
              top_title: 'Plato',
              top: ['Plato: Aros de cebolla', 'Plato local: Paella valenciana'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Sevilla',
          top: '350px',
          left: '320px',
          cuisines: [
            {
              cuisine: 'Tipo de cocina: Americana',
              image: 'burger-chips',
              top_title: 'Plato',
              top: [
                'Plato: Serranito de pollo',
                'Plato local: Serrano de presa Ibérica'
              ],
              color: 'tomato'
            }
          ]
        },
        {
          city: 'A Coruña',
          top: '100px',
          left: '160px',
          cuisines: [
            {
              cuisine: 'Tipo de cocina: Americana',
              image: 'burger',
              top_title: 'Plato',
              top: [
                'Plato: Hamburguesa de ternera',
                'Plato local: raxo con patatas'
              ],
              color: 'berry'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: 'Esto solo es un aperitivo, ¿quieres conocer el resto de datos?',
      body: 'Descarga el informe completo',
      button: 'Descargar PDF'
    },
    footer: {
      title: 'Contactos:',
      contacts: [
        {
          company: 'True PR:',
          name: 'Carlos Rija',
          email: 'carlos.rija@truepr.es',
          number: '687537557'
        },
        {
          company: 'Just Eat:',
          name: 'Laura Spínola',
          email: 'laura.spinola@justeattakeaway.com  '
        }
      ]
    }
  },
  it_it: {
    download:
      'https://www.flipsnack.com/takeawaycom/food-trend-report-italy-2021.html',
    navbar: {
      logo: 'just-eat',
      button_text: 'Scarica il pdf',
      home_link: 'https://www.justeat.it/'
    },
    intro: {
      hero: 'pizza-hero',
      title: 'La mappa del cibo a domicilio in Italia',
      subtitle: 'Quinta edizione',
      body:
        'Osservatorio nazionale sul mercato del cibo a domicilio online in Italia 2021'
    },
    favourites: {
      title: 'Analisi del Food Delivery in Italia',
      subtitle: `Cosa mettono nel piatto gli italiani? Dati e trend nazionali`,
      image: 'pizza-box',
      body_1: 'Le 5 cucine più popolari',
      body_2: '',
      food_items: [
        {
          image: 'pizza-plate',
          cuisine: 'Pizza',
          top: ['Margherita', 'Diavola', 'Capricciosa'],
          color: 'cupcake'
        },
        {
          image: 'burger',
          cuisine: 'Hamburger',
          top: ['Cheeseburger', 'Hamburger', 'Double cheeseburger'],
          color: 'orange'
        },
        {
          image: 'sushi',
          cuisine: 'Giapponese',
          top: ['Nigiri al salmone', 'Uramaki Ebiten', 'Sashimi di salmone'],
          color: 'tumeric'
        },
        {
          image: 'chinese',
          cuisine: 'Cinese',
          top: [
            'Involtini primavera',
            'Riso alla cantonese',
            ' Ravioli alla griglia'
          ],
          color: 'berry'
        },
        {
          image: 'poke-salmon',
          cuisine: 'Poke',
          top: ['Poke con salmone', 'Componi la tua poke', 'Poke con pollo'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Le opzioni veg*',
        body_1:
          'La cucina vegana sta guadagnando popolarità nel food delivery con un aumento del',
        body_2: '67%'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'I piatti vegetariani più amati:',
        dishes: [
          {
            name: ' Hamburger vegetariano',
            image: 'veggie-burger',
            color: 'cupcake'
          },
          {
            name: 'Wrap veggie',
            image: 'wrap-icon',
            color: 'berry'
          },
          {
            name: 'Hummus',
            image: 'kebab-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Piatti vegani preferiti:',
        dishes: ['Torta salata alle verdure', 'Pita Falafel', 'Babaganoush'],
        image: 'dahl'
      }
    },
    cuisines: {
      title: 'Le novità',
      subtitle: 'Le cucine e i piatti che stanno guadagnando popolarità',
      country: {
        title: 'Cucine',
        list: [
          'Libanese +93%',
          'Thailandese +61%',
          'Insalate +50%',
          'Specialità Regionali +43%',
          'Healthy +32%'
        ]
      },
      dish: {
        title: 'Piatti',
        list: [
          'Pad thai di gamberi',
          'Gyoza di carne',
          'Poke al salmone',
          'Frittatina di bucatini',
          'Jiaozi'
        ]
      },
      image: 'wrap'
    },
    cities: {
      title: 'I fan del food delivery',
      subtitle: 'Le dieci citta che più amano ordinare ',
      list: [
        'Roma',
        'Milano',
        'Napoli',
        'Torino',
        'Bologna',
        'Genova',
        'Firenze',
        'Trieste',
        'Verona',
        'Cagliari'
      ]
    },
    maps: {
      title: 'Analisi regionale del food delivery',
      subtitle: 'I cibi del cuore delle città italiane',
      body_1:
        'Scopri le cucine e i piatti più popolari nelle diverse città italiane*',
      body_2: '*dopo la pizza e la pizza margherita',
      image: 'map-it',
      locations: [
        {
          city: 'Milano',
          top: '190px',
          left: '130px',
          cuisines: [
            {
              cuisine: 'Cucina: Giapponese',
              image: 'sushi',
              top_title: 'Piatti',
              top: ['Involtini primavera', 'Diavola', 'Uramaki tiger roll'],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Roma',
          top: '450px',
          left: '250px',
          cuisines: [
            {
              cuisine: 'Cucina: Hamburger',
              image: 'burger',
              top_title: 'Piatti',
              top: ['Supplì', 'Involtini primavera', 'Olive ascolane'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Napoli',
          top: '540px',
          left: '350px',
          cuisines: [
            {
              cuisine: 'Cucina: Hamburger',
              image: 'burger-chips',
              top_title: 'Piatti',
              top: ['Crocchè', 'Diavola', 'Alette di pollo'],
              color: 'tumeric'
            }
          ]
        },
        {
          city: 'Torino',
          top: '260px',
          left: '50px',
          cuisines: [
            {
              cuisine: 'Cucina: Hamburger',
              image: 'burger',
              top_title: 'Piatti',
              top: ['Involtini primavera', 'Farinata', 'Diavola'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Cagliari',
          top: '660px',
          left: '120px',
          cuisines: [
            {
              cuisine: 'Cucina: Hamburger',
              image: 'burger-chips',
              top_title: 'Piatti',
              top: ['Napoli', 'Sarda', 'Nigiri al salmone'],
              color: 'tomato'
            }
          ]
        },
        {
          city: 'Genova',
          top: '320px',
          left: '50px',
          cuisines: [
            {
              cuisine: 'Cucina: Hamburger',
              image: 'burger',
              top_title: 'Piatti',
              top: [
                'Involtini primavera',
                'Riso alla cantonese',
                'Ravioli di carne'
              ],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Verona',
          top: '180px',
          left: '300px',
          cuisines: [
            {
              cuisine: 'Cucina: Giapponese',
              image: 'poke-tuna',
              top_title: 'Piatti',
              top: ['Involtini primavera', 'Uramaki roll', 'Salamino piccante'],
              color: 'orange'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: 'Vuoi scoprire più dati? ',
      body: 'Scarica qui il report completo',
      button: 'Scarica il pdf'
    },
    footer: {
      title: 'Contatti',
      contacts: [
        {
          company: 'Just Eat',
          name: 'Cristina Canale',
          email: 'cristina.canale@justeattakeaway.com'
        },
        {
          company: 'BCW | Burson Cohn & Wolfe',
          name: 'Alessandra Pedrona alessandra.pedrona@bcw-global.com  ',
          email: 'Francesca Cappello francesca.cappello@bcw-global.com',
          number: 'Tel. 02 721431 - Mob. 340 9048664'
        }
      ]
    }
  },
  ch_de: {
    download: 'it-booklet',
    navbar: {
      logo: 'just-eat',
      button_text: 'PDF Herunterladen',
      country_toggle: 'fr',
      country_link: 'https://www.just-eat.ch/',
      home_link: 'https://www.just-eat.ch/'
    },
    intro: {
      hero: 'burger-hero',
      title: 'Der Just Eat Schweiz-Report',
      subtitle: 'So bestellte die Schweiz 2021',
      body: `Datenauswertung des Schweizer Online Food Delivery Marktführers Just Eat`
    },
    favourites: {
      title: 'Die beliebtesten Küchen und ihre jeweiligen Top 3 Gerichte',
      subtitle: ``,
      image: 'pizza-box',
      body_1: '',
      body_2: '',
      food_items: [
        {
          image: 'pizza-slice',
          cuisine: 'Italienisch',
          top: ['Pizza Margherita', 'Pizza Prosciutto', 'Pizza Hawaii'],
          color: 'cupcake'
        },
        {
          image: 'burger',
          cuisine: 'Burger',
          top: ['Cheese Burger', 'Hamburger', 'Pommes Frites'],
          color: 'orange'
        },
        {
          image: 'curry',
          cuisine: 'Indisch',
          top: ['Garlic Naan', 'Tikka Masala', 'Palak Paneer'],
          color: 'tumeric'
        },
        {
          image: 'chinese',
          cuisine: 'Chinesisch',
          top: [
            'Poulet Sweet & Sour',
            'Fried Rice',
            'Gebratenes Rindfleisch mit Reis'
          ],
          color: 'berry'
        },
        {
          image: 'kebab',
          cuisine: 'Türkisch',
          top: ['Döner Box', 'Dürüm im Fladenbrot', 'Döner im Taschenbrot'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Veggie',
        body_1:
          'Vegetarische und vegane Ernährung wächst in ihrer Beliebtheit. Das zeigen auch die Bestellzahlen:',
        body_2:
          'So wurden 600% mehr vegetarische und vegane Gerichte bestellt als noch im Vorjahr!'
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Die beliebtesten vegetarischen Gerichte:',
        dishes: [
          {
            name: 'Pizza Margherita',
            image: 'pizza-plate',
            color: 'cupcake'
          },
          {
            name: 'Vegetarische Frühlingsrollen',
            image: 'wrap-icon',
            color: 'berry'
          },
          {
            name: 'Gemischter Salat',
            image: 'kebab-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Die beliebtesten veganen Gerichte:',
        dishes: ['Vegane Momos', 'Sushi-Rolle mit Mango', 'Beyond Burger'],
        image: 'veggie-burger'
      }
    },
    cuisines: {
      title: 'Die Aufsteiger',
      subtitle: 'Diese Küchen sind am schnellsten gewachsen',
      country: {
        title: 'Küchen',
        list: ['Dumplings / Momos', 'Schweizerisch', 'Griechisch-Mediterran']
      },
      dish: {
        title: 'Piatti',
        list: []
      },
      image: 'wrap'
    },

    cities: {
      title: 'In diesen Städten wird am meisten Essen bestellt (per capita)',
      subtitle: '',
      list: [
        'Wallisellen',
        'Kloten',
        'Biel',
        'Winterthur',
        'Lausanne',
        'Dübendorf',
        'Frauenfeld',
        'Genf',
        'Basel',
        'Zürich'
      ]
    },
    maps: {
      title: 'So bestellten die Kantone',
      subtitle: 'Eine kulinarische Tour durch die Schweiz ',
      body_1:
        '*Die Bestelldaten aller 26 Kantone sind im Report detailliert aufgelistet.',
      body_2: '',
      image: 'map-ch',
      locations: [
        {
          city: 'Kanton Basel-Stadt',
          top: '180px',
          left: '200px',
          cuisines: [
            {
              image: 'pizza-plate',
              top_title: 'Teller',
              top: ['Pizza Margherita', 'Pad Thai', 'Cheese Burger'],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Kanton Bern',
          top: '290px',
          left: '220px',
          cuisines: [
            {
              image: 'pizza-slice',
              top_title: 'Teller',
              top: ['Pizza Margherita', 'Pizza Prosciutto', 'Pommes Frites'],
              color: 'orange'
            }
          ]
        },
        {
          city: 'Kanton Genf',
          top: '450px',
          left: '0px',
          cuisines: [
            {
              image: 'burger',
              top_title: 'Teller',
              top: ['Cheese Burger', 'Poulet-Spiess', 'Pad Thai'],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Kanton Waadt',
          top: '350px',
          left: '80px',
          cuisines: [
            {
              image: 'chinese',
              top_title: 'Teller',
              top: ['Tacos', 'Pommes Frites', 'Pad Thai'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Kanton Zürich',
          top: '150px',
          left: '450px',
          cuisines: [
            {
              image: 'pizza-box',
              top_title: 'Teller',
              top: ['Pizza Margherita', 'Pizza Prosciutto', 'Pommes Frites'],
              color: 'tomato'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: 'Hungrig auf mehr Daten?',
      body: 'Hier kann der gesamte Report heruntergeladen werden',
      button: 'PDF Herunterladen'
    },
    footer: {
      title: 'Pressekontakt:',
      contacts: [
        {
          company: 'Just Eat Schweiz',
          name: 'Werdstrasse 21',
          email: '8004 Zürich',
          number: 'Séverine Götz',
          address: 'severine.goetz@justeattakeaway.com'
        }
      ]
    }
  },
  ch_fr: {
    download: 'it-booklet',
    navbar: {
      logo: 'just-eat',
      button_text: 'Télécharger le PDF',
      country_toggle: 'de',
      country_link: 'https://www.just-eat.ch/',
      home_link: 'https://www.just-eat.ch/'
    },
    intro: {
      hero: 'burger-hero',
      title: 'Au menu en Suisse en 2021',
      subtitle:
        'Observatoire de la livraison de repas à domicile en Suisse - Rapport Décembre 2021',
      body: ``
    },
    favourites: {
      title: `L'analyse nationale de Just Eat `,
      subtitle: `Les cuisines les plus populaires et leurs 3 plats phares `,
      image: 'pizza-box',
      body_1: '',
      body_2: '',
      food_items: [
        {
          image: 'pizza-slice',
          cuisine: 'Italien',
          top: ['Pizza Margherita', 'Pizza Prosciutto', 'Pizza Hawaïenne'],
          color: 'cupcake'
        },
        {
          image: 'burger',
          cuisine: 'Burger',
          top: ['Cheeseburger', 'Burger', 'Frites'],
          color: 'orange'
        },
        {
          image: 'curry',
          cuisine: 'Indien',
          top: ['Naan', 'Tikka Masala', 'Palak Paneer'],
          color: 'tumeric'
        },
        {
          image: 'chinese',
          cuisine: 'Chinois',
          top: ['Poulet Sweet & Sour', 'Riz Frit', 'Bœuf Sauté avec Riz'],
          color: 'berry'
        },
        {
          image: 'kebab',
          cuisine: 'Turc',
          top: ['Box Kebab', 'Galette Kebab', 'Kebab dans un Petit Pain'],
          color: 'aubergine'
        }
      ],
      vegetarian: {
        title: 'Veggie',
        body_1:
          'Les régimes végétariens et vegan sont de plus en plus populaires. Les chiffres des commandes le montrent également :',
        body_2: `les commandes de plats végétariens et vegan ont augmenté de 600% par rapport à l'année précédente !`
      }
    },
    vegetarian: {
      vegetarian_favourites: {
        title: 'Les plats végétariens les plus populaires :',
        dishes: [
          {
            name: 'Pizza Margherita',
            image: 'pizza-plate',
            color: 'cupcake'
          },
          {
            name: 'Rouleaux de Printemps Végétariens',
            image: 'wrap-icon',
            color: 'berry'
          },
          {
            name: 'Salade Composée',
            image: 'kebab-icon',
            color: 'tumeric'
          }
        ]
      },
      vegan_favourites: {
        title: 'Les plats vegan les plus populaires :',
        dishes: [
          'Momos Vegan',
          'Rouleau de Sushi à la Mangue',
          'Burger Beyond'
        ],
        image: 'veggie-burger'
      }
    },
    cuisines: {
      title: 'En hausse de popularité',
      subtitle: 'Ces cuisines ont gagné en popularité',
      country: {
        title: 'Cuisines',
        list: ['Dumplings / Momos', 'Suisse', 'Grecque-Méditerranéenne']
      },
      dish: {
        title: 'Piatti',
        list: []
      },
      image: 'wrap'
    },

    cities: {
      title: 'Les villes où l’on commande le plus de repas (per capita)',
      subtitle: '',
      list: [
        'Wallisellen',
        'Kloten',
        'Bienne',
        'Winterthour',
        'Lausanne',
        'Dübendorf',
        'Frauenfeld',
        'Genève',
        'Bâle',
        'Zurich'
      ]
    },
    maps: {
      title: 'Les habitudes de consommation dans les cantons',
      subtitle: 'Un tour d’horizon culinaire de la Suisse',
      body_1:
        '*Les données de commande des 26 cantons sont listées en détail dans le rapport.',
      body_2: '',
      image: 'map-ch',
      locations: [
        {
          city: 'Bâle-Ville',
          top: '180px',
          left: '200px',
          cuisines: [
            {
              image: 'pizza-plate',
              top_title: 'Plaque',
              top: ['Pizza Margherita', 'Pad Thaï', 'Cheeseburger'],
              color: 'aubergine'
            }
          ]
        },
        {
          city: 'Berne',
          top: '290px',
          left: '220px',
          cuisines: [
            {
              image: 'pizza-slice',
              top_title: 'Plaque',
              top: ['Pizza Margherita', 'Pizza Prosciutto', 'Frites'],
              color: 'orange'
            }
          ]
        },
        {
          city: 'Genève',
          top: '450px',
          left: '0px',
          cuisines: [
            {
              image: 'burger',
              top_title: 'Plaque',
              top: ['Cheeseburger', 'Brochette de Poulet', 'Pad Thaï'],
              color: 'cupcake'
            }
          ]
        },
        {
          city: 'Vaud',
          top: '350px',
          left: '80px',
          cuisines: [
            {
              image: 'chinese',
              top_title: 'Plaque',
              top: ['Tacos', 'Frites', 'Pad Thaï'],
              color: 'berry'
            }
          ]
        },
        {
          city: 'Zurich',
          top: '150px',
          left: '450px',
          cuisines: [
            {
              image: 'pizza-box',
              top_title: 'Plaque',
              top: ['Pizza Margherita', 'Pizza Prosciutto', 'Frites'],
              color: 'tomato'
            }
          ]
        }
      ]
    },
    outro: {
      image: 'egg-burger',
      title: `Envie d'en savoir plus?`,
      body: 'Téléchargez le rapport complet',
      button: 'Télécharger le PDF'
    },
    footer: {
      title: 'Contacts presse:',
      contacts: [
        {
          company: 'Just Eat Suisse',
          name: 'Werdstrasse 21',
          email: '8004 Zurich',
          number: 'Séverine Götz',
          address: 'severine.goetz@justeattakeaway.com'
        }
      ]
    }
  }
}
